
import React from 'react';

interface ContentSectionProps {
  title: string;
  children: React.ReactNode;
}

const ContentSection = ({ title, children }: ContentSectionProps) => {
  return (
    <div className="bg-gray-50 rounded-lg p-8 mb-12 shadow-xl">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">{title}</h2>
      <div className="space-y-6 text-gray-700">
        {children}
      </div>
    </div>
  );
};

export default ContentSection;
